/* smoke-alumno (S11): NADA DE STUDYBUDDY PUEDE PAUSAR LA MUSICA DEL USUARIO.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Carlos lo vio en Safari del iPhone: al tocar botones se le pausaba Spotify. Nuestro codigo no suena, pero una
   pagina puede tomar la sesion de audio del telefono sin sonar (un `AudioContext` que se crea, aunque no toque nada:
   lo hace la huella de FingerprintJS en WebKit, ver `Downloads\bench_eq\smoke_alumno\audio_hallazgos.md`). La red de
   seguridad: al arrancar, si el navegador tiene la API de sesion de audio (`navigator.audioSession`, Safari 16.4 y
   despues, tambien en el WKWebView de la app), se pone en "ambient", el tipo que MEZCLA cualquier sonido de la pagina
   con la musica en vez de pausarla. Con comprobacion de que existe y dentro de un `try`: donde no existe, o truena,
   no pasa nada. Devuelve true si la sesion quedo en "ambient". */

export function ponerSesionDeAudioAmbiente(nav = (typeof navigator !== 'undefined' ? navigator : undefined)) {
  try {
    const sesion = nav ? nav.audioSession : undefined;
    if (!sesion || typeof sesion !== 'object') return false;
    if (sesion.type !== 'ambient') sesion.type = 'ambient';
    return sesion.type === 'ambient';
  } catch {
    return false;
  }
}
